import request from "./config";
export default class UsuarioService {
  static getExample(query = {}) {
    return request({
      url: "/details",
      method: "get",
      timeout: 10000,
      params: query,
    });
  }

  static sendFormBuzon(data, onUploadProgress) {
    return request({
      url: "/company/create-message",
      method: "post",
      timeout: 10000000,
      data,
      onUploadProgress,
    });
  }
  static createCompany(data) {
    return request({
      url: "/user/company/create",
      method: "post",
      timeout: 100000,
      data,
    });
  }
  static createLink() {
    return request({
      url: "/company/link-generate",
      method: "post",
      timeout: 100000,
    });
  }
  static listLink(query = {}) {
    return request({
      url: "/company/list",
      method: "get",
      timeout: 100000,
      params: query
    });
  }
  static listSlug(slug) {
    return request({
      url: "/company/" + slug,
      method: "get",
      timeout: 60000,
    });
  }

  static searchCompanyBySlug(slug) {
    return request({
      url: "/company/search/"+ slug,
      method: "GET",
      timeout: 60000,
    });
  }


  static confirm(data) {
    return request({
      url: "/users/confirm",
      method: "post",
      data,
    });
  }
  static login(data) {
    return request({
      url: "/users/login",
      timeout: 60000,
      method: "POST",
      data,
    });
  }
  static passwordRecuva(data) {
    return request({
      url: "/users/password-recuva",
      method: "post",
      timeout: 60000,
      data: data,
    });
  }
  static confirmPasswordRecuva(data) {
    return request({
      url: "/users/password-confirm",
      method: "post",
      timeout: 60000,
      data: data,
    });
  }
  static signupcompany(data) {
    return request({
      url: "/users/signup",
      method: "POST",
      timeout: 60000,
      data,
    });
  } 
  static listMessages() {
    return request({
      url: "/company/listMessages",
      method: "get",
    });
  }
  static listUsersCompany(params) {
    return request({
      url: "/admin/users-of-the-company/",
      method: "get",
      params: params,
      timeout: 100000,
    });
  }
  static changeAccountSuspended(data) {
    return request({
      url: "/company/change-account-suspended",
      method: "put",
      data,
      timeout: 100000,
    });
  }
  static updateUser(data) {
    return request({
      url: "/user/edit",
      method: "put",
      data,
      timeout: 100000,
    });
  }
  static removeUser(data) {
    return request({
      url: "/company/user/remove",
      method: "post",
      data,
      timeout: 100000,
    });
  }
  static sendImportBuzon(data) {
    return request({
      url: "/company/import-message",
      method: "post",
      timeout: 300000,
      data,
    });
  }
  static createAppUser(data) {
    return request({
      url: "/user/company/createUser",
      method: "post",
      timeout: 100000,
      data,
    });
  }

  static confirmOtp(data) {
    return request({
      url: "/auth/account/verify-otp",
      method: "post",
      data,
    });
  }

  static logout() {
    return request({
      url: "/users/logout",
      method: "POST",
      timeout: 10000,
    });
  }
}
